import React from 'react';
import Styles from './styles.module.scss';

const SectionDivider = ({ size }) => (<div className={`${Styles['divider']} ${size ? `my-${size}` : 'my-60'}`}></div>)


export default SectionDivider;